import { createPopup } from 'deskfy-custom-popup-picker'

;(function () {
  'use strict'

  angular
    .module('deskfy.core')
    .controller('InputEmojiController', InputEmojiController)

  /* @ngInject */
  function InputEmojiController ($scope, $attrs, $translate, $timeout) {
    let emojiPopup

    const api = {
      _createDialog
    }
    this.getApi = () => api

    activate()

    function activate () {
      $timeout(() => api._createDialog(), 300, false)
    }

    $scope.toggleDialog = function () {
      emojiPopup.toggle()
    }

    function _createDialog () {
      const i18n = {
        'categories.activities': $translate.instant('emojisCategories.activities'),
        'categories.animals-nature': $translate.instant('emojisCategories.animalsNature'),
        'categories.flags': $translate.instant('emojisCategories.flags'),
        'categories.food-drink': $translate.instant('emojisCategories.foodDrink'),
        'categories.objects': $translate.instant('emojisCategories.objects'),
        'categories.people-body': $translate.instant('emojisCategories.peopleBody'),
        'categories.recents': $translate.instant('emojisCategories.recents'),
        'categories.smileys-emotion': $translate.instant('emojisCategories.smileysEmotion'),
        'categories.symbols': $translate.instant('emojisCategories.symbols'),
        'categories.travel-places': $translate.instant('emojisCategories.travelPlaces')
      }

      const [emojiArea] = $attrs.$$element.find('.emoji-area')
      const [emojiDialog] = $attrs.$$element.find('.emoji-dialog')

      emojiPopup = createPopup(
        {
          rootElement: emojiDialog,
          showSearch: false,
          showPreview: false,
          emojisPerRow: 9,
          emojiSize: '1.7rem',
          i18n
        },
        {
          triggerElement: emojiArea,
          referenceElement: emojiArea,
          position: 'bottom-start',
          className: 'emoji-picker'
        }
      )

      emojiPopup.addEventListener('emoji:select', event => {
        $scope.model = event.emoji
        $scope.change(event.emoji)
        $scope.$apply()
      })
    }
  }
})()
